module.exports = __webpack_public_path__ + "static/media/activity-import-template.3734e587.csv";